import './index.scss'
import AnimatedLetters from '../AnimatedLetters/index'
import { useState, useEffect } from 'react';
import Portrait from '../Home/Portrait/index';
import Loader from 'react-loaders';

const About = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            return setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
            <div className='container about-page'>
                <div className='text-zone'>
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass} 
                            strArray={['A','b','o','u','t',' ', 'M','e']}
                            idx={15}
                        />
                    </h1>
                    <p>
                        Hey there, a little bit about me is that I am a current senior at Abilene Christian University 
                        majoring in Computer Science with a concentration in Software Engineering. I am involved in 
                        various organizations such as ACU SGA, Galaxy Social Club/Fraternity, ACU Wind Ensemble, 
                        and the Civic Orchestra of Abilene. 
                    </p>
                    <p>
                        I am seeking to expand my knowledge about the software engineering industry by utilizing my skills
                        that I have acquired throughout my studies and experience. My current interests in the field of Computer 
                        Science and Software Engineering are web development, UX design, and machine learning. 
                    </p>
                    <p>
                        I have previous work experience with working IT Support for Team55 which is ACU's own technology support
                        for faculty and students. Additionally, I am a current Software Engineer Intern for iHeartMedia Inc. working 
                        with the Salesforce team to integrate and automate their processes. I am most familiar with the MERN and PERN
                        tech stacks. Also, I am proficient in the following languages C/C++, C#, Python, Java, Javascript, SQL, HTML/CSS,  
                        and Swift. 
                    </p>
                </div>
                <Portrait/>
            </div>
            <Loader type='pacman'/>
        </>
    )
}

export default About